import { ShowCashAccountType } from './api/member/member.interface';

export const relationTypeCategoryList: string[] = [
  '자',
  '아 들',
  '상 주',
  '자 부',
  '며느리',
  '녀',
  '딸',
  '사 위',
  '손',
  '손 자',
  '손 녀',
  '부 군',
  '배우자',
  '부',
  '모',
  '형 제',
  '자 매',
  '손 부',
  '손 서',
  '외 손',
  '외손자',
  '외손녀',
  '미망인',
  '兄弟',
  '姊妹',
  '子',
  '女',
  '孫',
];

export const DeathCharacter = '故';

// 금융기관 타입
export enum FinancialInstitutionType {
  Bank = 'bank',
  Securities = 'securities',
}

export enum BankEnum {
  // 은행
  국민 = '국민',
  신한 = '신한',
  하나 = '하나',
  우리 = '우리',
  IBK기업 = 'IBK기업',
  농협 = '농협',
  KDB산업 = 'KDB산업',
  수협 = '수협',
  우체국 = '우체국',
  한국씨티 = '한국씨티',
  SC제일 = 'SC제일',
  카카오뱅크 = '카카오뱅크',
  케이뱅크 = '케이뱅크',
  토스뱅크 = '토스뱅크',
  경남 = '경남',
  광주 = '광주',
  iM뱅크 = 'iM뱅크(대구)',
  부산 = '부산',
  전북 = '전북',
  제주 = '제주',
  저축 = '저축',
  산림조합 = '산림조합',
  새마을금고 = '새마을금고',
  신협 = '신협',
  도이치 = '도이치',
  중국건설 = '중국건설',
  중국공상 = '중국공상',
  중국은행 = '중국은행',
  HSBC = 'HSBC',
  BNP파리바 = 'BNP파리바',
  JP모간체이스 = 'JP모간체이스',
  지역농축협 = '지역농축협',
  BOA = 'BOA',
  // 증권사
  유안타증권 = '유안타증권',
  KB증권 = 'KB증권',
  상상인증권 = '상상인증권',
  BNK투자증권 = 'BNK투자증권',
  IBK투자증권 = 'IBK투자증권',
  다올투자증권 = '다올투자증권',
  미래에셋증권 = '미래에셋증권',
  삼성증권 = '삼성증권',
  한국투자증권 = '한국투자증권',
  NH투자증권 = 'NH투자증권',
  교보증권 = '교보증권',
  IM증권 = 'IM증권',
  현대차증권 = '현대차증권',
  키움증권 = '키움증권',
  LS증권 = 'LS증권',
  SK증권 = 'SK증권',
  대신증권 = '대신증권',
  한화투자증권 = '한화투자증권',
  하나증권 = '하나증권',
  토스증권 = '토스증권',
  신한금융투자 = '신한금융투자',
  DB금융투자 = 'DB금융투자',
  유진투자증권 = '유진투자증권',
  메리츠증권 = '메리츠증권',
  카카오페이증권 = '카카오페이증권',
  부국증권 = '부국증권',
  신영증권 = '신영증권',
  케이프투자증권 = '케이프투자증권',
  우리투자증권 = '우리투자증권',
}

// 은행 목록
export const bankOnlyList: BankEnum[] = [
  BankEnum.국민,
  BankEnum.신한,
  BankEnum.하나,
  BankEnum.우리,
  BankEnum.IBK기업,
  BankEnum.농협,
  BankEnum.KDB산업,
  BankEnum.수협,
  BankEnum.우체국,
  BankEnum.한국씨티,
  BankEnum.SC제일,
  BankEnum.카카오뱅크,
  BankEnum.케이뱅크,
  BankEnum.토스뱅크,
  BankEnum.경남,
  BankEnum.광주,
  BankEnum.iM뱅크,
  BankEnum.부산,
  BankEnum.전북,
  BankEnum.제주,
  BankEnum.저축,
  BankEnum.산림조합,
  BankEnum.새마을금고,
  BankEnum.신협,
  BankEnum.도이치,
  BankEnum.중국건설,
  BankEnum.중국공상,
  BankEnum.중국은행,
  BankEnum.HSBC,
  BankEnum.BNP파리바,
  BankEnum.JP모간체이스,
  BankEnum.지역농축협,
  BankEnum.BOA,
];

// 증권사 목록
export const securitiesList: BankEnum[] = [
  BankEnum.유안타증권,
  BankEnum.KB증권,
  BankEnum.상상인증권,
  BankEnum.BNK투자증권,
  BankEnum.IBK투자증권,
  BankEnum.다올투자증권,
  BankEnum.미래에셋증권,
  BankEnum.삼성증권,
  BankEnum.한국투자증권,
  BankEnum.NH투자증권,
  BankEnum.교보증권,
  BankEnum.IM증권,
  BankEnum.현대차증권,
  BankEnum.키움증권,
  BankEnum.LS증권,
  BankEnum.SK증권,
  BankEnum.대신증권,
  BankEnum.한화투자증권,
  BankEnum.하나증권,
  BankEnum.토스증권,
  BankEnum.신한금융투자,
  BankEnum.DB금융투자,
  BankEnum.유진투자증권,
  BankEnum.메리츠증권,
  BankEnum.카카오페이증권,
  BankEnum.부국증권,
  BankEnum.신영증권,
  BankEnum.케이프투자증권,
  BankEnum.우리투자증권,
];

// 전체 금융기관 목록 (은행 + 증권사)
export const bankCategoryList: BankEnum[] = [...bankOnlyList, ...securitiesList];

// 금융기관 타입 확인 함수
export const getFinancialInstitutionType = (bank: BankEnum): FinancialInstitutionType => {
  return securitiesList.includes(bank)
    ? FinancialInstitutionType.Securities
    : FinancialInstitutionType.Bank;
};

export const accountDisplayPreferenceList = [
  {
    label: '본인계좌만 표시',
    value: ShowCashAccountType.Self,
  },
  {
    label: '모든 상주계좌 표시',
    value: ShowCashAccountType.All,
  },
];
